import React from "react";
import "../pages/LandingPage.css";

export default function Rules() {
  return (
    // <div className="rulesContainer">
    //   <p style={{ textAlign: "center", fontWeight: "bold" }}>
    //     टीवी टुडे नेटवर्क लिमिटेड और माइक के लाल कार्यक्रम
    //   </p>
    //   <p>
    //     टीवी टुडे नेटवर्क लिमिटेड ("टीवीटीएन") कविता, कहानी, स्टैंड-अप और कॉमेडी
    //     के लिए एक ओपन माइक कार्यक्रम 'माइक के लाल' का आयोजन कर रहा है। इस
    //     कार्यक्रम में भाग लेने के लिए, टीवीटीएन इस फॉर्म के माध्यम से
    //     प्रविष्टियां आमंत्रित कर रहा है।
    //   </p>
    //   <p>
    //     प्रतिभागियों को कार्यक्रम में भाग लेने से पहले निम्नलिखित नियमों और
    //     शर्तों को पढ़ने और समझने के लिए कहा जाता है। उपरोक्त विवरण प्रस्तुत करने
    //     का अर्थ यह होगा कि प्रतिभागी ने कार्यक्रम के नियमों और शर्तों को पढ़ और
    //     समझ लिया है और इसका अनिवार्य रूप से पालन करने का वचन देता है।
    //   </p>
    //   <p>
    //     नीचे दिए गए नियम और शर्तें इस कार्यक्रम का हिस्सा हैं और प्रतिभागियों के
    //     लिए समान रूप से बाध्य हैं।
    //   </p>
    //   <p style={{ fontWeight: "bold" }}>नियम एवं शर्तें</p>
    //   <p>
    //     टीवीटीएन 'माइक के लाल' ("इवेंट") नामक एक ओपन माइक इवेंट का आयोजन कर रहा
    //     है। यह कार्यक्रम निम्नलिखित नियम और शर्तों ("नियम और शर्तें") के अधीन
    //     है। यदि कोई भी प्रतिभागी इन नियमों और शर्तों से सहमत नहीं है, तो ऐसे
    //     प्रतिभागी को कार्यक्रम में भाग नहीं लेने की सलाह दी जाती है और टीवीटीएन
    //     का ऐसे प्रतिभागी के प्रति किसी भी तरह से कोई दायित्व नहीं होगा।
    //     कार्यक्रम में भाग लेना या प्रविष्टि प्रस्तुत करना, या कार्यक्रम के लिए
    //     कोई भी लेनदेन करना ऐसे प्रतिभागी द्वारा नियम और शर्तों की स्वीकृति माना
    //     जाएगा। टीवीटीएन के पास यह अधिकार सुरक्षित है कि वह इवेंट के सभी या किसी
    //     भी नियम और शर्तों में संशोधन/परिवर्तन/बदलाव/समाप्त कर सकता है या बिना
    //     किसी पूर्व सूचना के किसी भी समय इवेंट को समाप्त कर सकता है। कार्यक्रम
    //     में प्रवेश करके, प्रतिभागी समय-समय पर संशोधित की जाने वाली शर्तों से
    //     सहमत होता है। टीवीटीएन किसी भी तरह से किसी भी व्यक्ति या कार्यक्रम में
    //     भाग लेने वाले व्यक्तियों को क्षतिपूर्ति करने के लिए बाध्य नहीं है।
    //   </p>
    //   <p>
    //     इन नियमों और शर्तों के प्रयोजनों के लिए, जहां कहीं भी संदर्भ की आवश्यकता
    //     हो, "आप" या "आपका" का अर्थ किसी भी प्राकृतिक व्यक्ति से होगा जो नियम और
    //     शर्तों के अनुसार कार्यक्रम में पात्र भागीदार है और "कंपनी", टीवीटीएन
    //     "हम", "हम" और / या "हमारा" का अर्थ टीवी टुडे नेटवर्क लिमिटेड, कंपनी
    //     अधिनियम, 1956 के तहत पंजीकृत कंपनी होगा और इसका पंजीकृत कार्यालय एफ-26,
    //     फर्स्ट फ्लोर, कनॉट सर्कस, नई दिल्ली- 110001, भारत में है।
    //   </p>
    //   <p style={{ fontWeight: "bold" }}>कार्यक्रम का नाम और अवधि:</p>
    //   <p style={{ fontWeight: "bold" }}>कार्यक्रम का नाम: माइक के लाल</p>
    //   <ul>
    //     <li>
    //       यह कार्यक्रम 18, 19 और 20 नवंबर, 2023 को मेजर ध्यानचंद नेशनल स्टेडियम,
    //       नई दिल्ली में आयोजित होने वाला है। टीवीटीएन अपने विवेकाधिकार पर बिना
    //       किसी पूर्व सूचना के कार्यक्रम की अवधि को बढ़ा या सीमित कर सकता है या
    //       कार्यक्रम के स्थान को बदल सकता है।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>पात्रता:</p>
    //   <ul>
    //     <li>
    //       यह कार्यक्रम केवल उन सदस्यों के लिए खुला है जो भारतीय नागरिक हैं और
    //       भारत के निवासी हैं और जिनकी आयु 18 वर्ष या उससे अधिक है और जो
    //       कार्यक्रम में प्रवेश के समय भारत में भौतिक रूप से स्थित हैं और निवास
    //       कर रहे हैं। 18 वर्ष से कम आयु के प्रतिभागी अपने माता-पिता या
    //       अभिभावक(कों) के माध्यम से कार्यक्रम में भाग ले सकते हैं।
    //     </li>
    //     <li>
    //       टीवीटीएन के कर्मचारी, निदेशक और अधिकारी, और उनके तत्काल परिवार (पति या
    //       पत्नी, माता-पिता, बच्चे, भाई-बहन, और उनके संबंधित पति), और टीवीटीएन के
    //       उनके संबंधित घर के सदस्य, इसके सहयोगी, सहायक, और प्रभाग, विज्ञापन और
    //       प्रचार एजेंसियां, और डिजाइन, निष्पादन, उत्पादन, विकास से जुड़े अन्य
    //       सभी, और इस कार्यक्रम का प्रचार या इस कार्यक्रम से जुड़े हुए हैं, किसी
    //       भी तरह से इस कार्यक्रम में भाग लेने के लिए पात्र नहीं हैं।
    //     </li>
    //     <li>
    //       प्रतिभागी टीवीटीएन को वचन, वारंट और गारंटी देते हैं कि प्रतिभागी के
    //       पास इन नियमों और शर्तों के अनुसार कार्यक्रम में भाग लेने की पूरी
    //       कानूनी क्षमता है।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>भाग कैसे लें:</p>
    //   <p>पात्र प्रतिभागियों को नीचे उल्लिखित नियमों का पालन करना होगा:</p>
    //   <p style={{ fontWeight: "bold" }}>ऑडियो के लिए:</p>
    //   <ul>
    //     <li>
    //       प्रतिभागी (ओं) प्रदर्शन की पूरी ऑडियो रिकॉर्डिंग फ़ाइल ("ऑडियो")
    //       संलग्न करेंगे, जिसे वे चयनित होने पर कार्यक्रम के दौरान करना चाहते
    //       हैं।
    //     </li>

    //     <li>
    //       ऑडियो मोबाइल फोन का उपयोग करके रिकॉर्ड किया जाना चाहिए और अधिकतम 5
    //       (पांच) मिनट की अवधि के लिए होना चाहिए।
    //     </li>

    //     <li>
    //       ऑडियो को निम्नलिखित प्रारूपों में से किसी एक में अपलोड किया जाना
    //       चाहिए, अर्थात .mp3, .wav., .m4a, .ogg, .wma, .mka, .aac, .midi
    //     </li>

    //     <li>ऑडियो फ़ाइल 10 एमबी से अधिक नहीं होना चाहिए</li>

    //     <li>
    //       ऑडियो उस समय से कम का नहीं होना चाहिए जब आप प्रदर्शन करना चाहते हैं।
    //       पूरा ऑडियो संलग्न करें।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>ये न करें:</p>
    //   <ul>
    //     <li>इस फॉर्म को एक से अधिक बार न भरें। आपको अयोग्य कर दिया जाएगा।</li>
    //     <li>
    //       अपने आवेदन की स्थिति के बारे में जानने के लिए हमें कॉल या मेल न करें।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>गोपनीयता:</p>
    //   <ul>
    //     <li>
    //       प्रतिभागी यह दर्शाता है कि वे इवेंट में प्रदर्शन की जाने वाली सभी
    //       सामग्रियों के एकमात्र, पूर्ण, भार-रहित, कानूनी और लाभकारी स्वामी हैं
    //       और टीवीटीएन और/या इसके कार्यवाहकों को दिए गए अधिकार हैं। प्रतिभागी के
    //       पास टीवीटीएन को वर्तमान स्वरूप में दिए गए ऐसे अधिकार और सहमति प्रदान
    //       करने का अधिकार है और यह किसी भी विकलांगता, प्रतिबंध या निषेध के तहत
    //       नहीं है जो प्रतिभागी को उनके किसी भी दायित्व के प्रदर्शन या पालन से
    //       रोकता है।
    //     </li>
    //     <li>
    //       कार्यक्रम में प्रवेश करके, प्रतिभागी सभी कॉपीराइट, प्रचार के अधिकार और
    //       टीवीटीएन के एक प्रतिभागी के रूप में चित्र, रिकॉर्ड, टेप या उसे चित्रित
    //       करने के अधिकार के लिए सहमति देता है,और इस सामग्री या प्रदर्शन को अब
    //       मौजूदा या इसके बाद बनाए गए किसी भी और सभी मीडिया में प्रदर्शित या
    //       सार्वजनिक करने के लिए,और बिना किसी सीमा के टेलीविजन, फिल्म, रेडियो,
    //       डिजिटल और प्रिंट मीडिया, प्रसारण, पुन: प्रसारण, विज्ञापन और प्रचार
    //       उद्देश्यों के लिए किसी भी मुआवजे के बिना, सहित किसी भी संबंधित अधिकार
    //       को छोड़ देता है, जहां कानून द्वारा निषिद्ध है। प्रतिभागी टीवीटीएन के
    //       अपने नाम, वीडियो, आवाज या चित्र, या उसके कार्यक्रम प्रविष्टि/प्रदर्शन
    //       आदि की सामग्री (सामूहिक रूप से, "प्रचार अधिकार") का उपयोग करने के
    //       अधिकार के लिए भी सहमति देता है। कार्यक्रम में एक प्रतिभागी की भागीदारी
    //       के बावजूद, टीवीटीएन की ओर से कोई भी प्रदर्शन / कार्यक्रम जिसमें उसने
    //       भाग लिया है, या टीवीटीएन द्वारा दर्ज किए गए उसके किसी भी या सभी योगदान
    //       को प्रसारित करने के लिए कोई दायित्व नहीं है।
    //     </li>
    //     <li>
    //       कानून के तहत लागू सीमा तक, प्रतिभागी इसके तहत टीवीटीएन के अधिकारों के
    //       प्रयोग के संबंध में दुनिया के किसी भी देश में "ड्रोइट नैतिक" या किसी
    //       भी समान कानून के रूप में ज्ञात कानून के तहत अनुमेय सीमा तक कानून के
    //       किसी भी प्रावधान के लाभ को अपरिवर्तनीय और बिना शर्त माफ करने के लिए
    //       सहमत हैं, और इसके द्वारा अपरिवर्तनीय रूप से और बिना शर्त किसी भी लागू
    //       कानूनों के तहत सभी आवश्यक सहमति प्रदान करता है और कार्यक्रम में इसके
    //       प्रदर्शन के संबंध में किए गए सभी संशोधनों के साथ कॉपीराइट अधिनियम,
    //       1957 की धारा 38-बी के तहत अपने नैतिक अधिकारों का त्याग करता है।
    //     </li>
    //     <li>
    //       कार्यक्रम के उद्देश्य के लिए प्रविष्टियां/पंजीकरण करके, प्रतिभागी
    //       टीवीटीएन को एसएमएस, ई-मेल भेजने या उसे कॉल करने की अनुमति देता है,
    //       चाहे ऐसा प्रेषक नेशनल डू नॉट कॉल रजिस्ट्री पर पंजीकृत हो या नहीं।
    //     </li>
    //     <li>
    //       कार्यक्रम में प्रवेश करके, प्रतिभागी टीवीटीएन के प्रचार और अन्य
    //       सामग्रियों के लिए मेलिंग/एसएमएस सूची में शामिल होने की सहमति देते हैं।
    //     </li>
    //     <li>
    //       प्रतिभागी अपनी वेबसाइट पर दी गई टीवीटीएन की{" "}
    //       <a href="https://www.indiatodaygroup.com/privacy-policy.html">
    //         गोपनीयता नीति
    //       </a>{" "}
    //       के अधीन होंगे। कृपया ध्यान दें कि किसी प्रतिभागी द्वारा टीवीटीएन को
    //       कोई भी जानकारी प्रदान करना उसकी पसंद पर निर्भर करता है। कार्यक्रम में
    //       प्रवेश करके, एक प्रतिभागी टीवीटीएन को ऐसे प्रतिभागियों द्वारा प्रदान
    //       की गई जानकारी का उपयोग करने की अनुमति देने के लिए सहमत होता है।
    //     </li>
    //     <li>
    //       टीवीटीएन त्रुटियों, समयबद्धता, विलोपन, गलत वितरण या किसी भी उपयोगकर्ता
    //       संचार या वैयक्तिकरण सेटिंग्स को संग्रहीत करने में विफलता के लिए कोई
    //       जिम्मेदारी नहीं लेता है।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>दायित्व / जिम्मेदारी:</p>
    //   <ul>
    //     <li>
    //       टीवीटीएन ऐसी प्रविष्टियों/पंजीकरणों की सटीकता, उपयोगिता, सुरक्षा, या
    //       बौद्धिक संपदा अधिकारों या उससे संबंधित के लिए ज़िम्मेदार नहीं है।
    //       प्रतिभागी आगे समझता है और स्वीकार करता/करती है कि वह गलत, आपत्तिजनक,
    //       अशोभनीय या आपत्तिजनक प्रविष्टियों/लेनदेनों के संपर्क में आ सकता/सकती
    //       है, और वह छूट देने के लिए सहमत है, और इसके संबंध में टीवीटीएन के खिलाफ
    //       उसके पास या उसके पास होने वाले किसी भी कानूनी या न्यायसंगत अधिकार या
    //       उपचार को छोड़ देता है, और टीवीटीएन, उसके मालिकों/ऑपरेटरों, सहयोगियों,
    //       और/या लाइसेंसकर्ताओं को क्षतिपूर्ति करने और रखने के लिए सहमत है, जो
    //       वेबसाइट तक उसकी पहुंच या उसके उपयोग से संबंधित सभी मामलों के संबंध में
    //       कानून द्वारा अनुमत पूर्ण सीमा तक हानिरहित है।
    //     </li>

    //     <li>
    //       टीवीटीएन, जिसमें उनके डिवीजन, सहयोगी, सहयोगी और सहायक कंपनियां और उनके
    //       संबंधित एजेंट, प्रतिनिधि, मालिक, निदेशक, कर्मचारी, अधिकारी, वितरक,
    //       खुदरा विक्रेता, और विज्ञापन / प्रचार एजेंसियां, शामिल हैं, किसी भी
    //       कारण से प्रविष्टियों / लेनदेन के किसी भी नुकसान के लिए जिम्मेदार नहीं
    //       हैं, किसी भी कारण से, सेवा प्रदाताओं, तकनीकी व्यवधान और / या विफलता /
    //       सर्वर की समस्याओं और / या किसी भी अन्य कठिनाइयों के कारण, जो किसी भी
    //       कारण से इस फॉर्म को भरने की अंतिम तिथि से पहले या किसी भी अन्य
    //       कठिनाइयों का सामना कर रहे हों या किसी भी कारण से इस फॉर्म को भरने की
    //       अंतिम तिथि के बाद प्राप्त प्रविष्टियों/लेनदेनों के लिए।
    //       प्रविष्टियां/लेनदेन शून्य हैं यदि, गलत, अपूर्ण, क्षतिग्रस्त, छेड़छाड़,
    //       मिथ्याकरण, यंत्रवत् पुन: प्रस्तुत, किसी भी तरह से अनियमित या अन्यथा इन
    //       नियमों और शर्तों के अनुपालन में नहीं है।
    //     </li>

    //     <li>
    //       टीवीटीएन यहां निहित नियमों और शर्तों में किसी भी त्रुटि या चूक के लिए
    //       जिम्मेदार नहीं होगा। कार्यक्रम में प्रदान की गई सभी जानकारी किसी भी
    //       प्रकार की वारंटी के बिना "जैसी है" प्रदान की जाती है। टीवीटीएन
    //       प्रतिभागी और/या किसी भी तीसरे पक्ष को किसी भी प्रकार की सभी व्यक्त,
    //       निहित, और वैधानिक वारंटी का कोई प्रतिनिधित्व नहीं करता है और अस्वीकार
    //       करता है, जिसमें बिना किसी सीमा के, सटीकता, समयसीमा, पूर्णता,
    //       व्यापारिकता, या किसी विशेष उद्देश्य के लिए उपयुक्तता की वारंटी शामिल
    //       है।
    //     </li>

    //     <li>
    //       किसी भी परिस्थिति में, टीवीटीएन या उसके सहयोगी और सहायक कंपनियां और/या
    //       उनके संबंधित एजेंट, प्रतिनिधि, मालिक के निदेशक, कर्मचारी, अधिकारी,
    //       वितरक, खुदरा विक्रेता, और विज्ञापन/प्रचार एजेंसियां किसी भी खोए हुए
    //       लाभ या खोए अवसर, अप्रत्यक्ष, विशेष, परिणामी, आकस्मिक, या दंडात्मक
    //       क्षति के लिए प्रतिभागी / उपयोगकर्ता और/या किसी तीसरे पक्ष के प्रति
    //       उत्तरदायी नहीं होंगी, भले ही टीवीटीएन को इस तरह के नुकसान की संभावना
    //       की सलाह दी गई हो।
    //     </li>

    //     <li>
    //       टीवीटीएन या उसका कोई भी सहयोगी आय के किसी भी नुकसान के लिए उत्तरदायी
    //       नहीं होगा, या अन्यथा प्रतिभागी को हुई और कार्यक्रम में उसकी भागीदारी
    //       के परिणामस्वरूप उत्पन्न हुआ।
    //     </li>

    //     <li>
    //       टीवीटीएन के अपने दायित्वों को पूरा करने में किसी भी तरह की विफलता को
    //       उस हद तक माफ कर दिया जाएगा, जब तक कि इस तरह के प्रदर्शन को टीवीटीएन
    //       ("अप्रत्याशित घटना") के उचित नियंत्रण से परे ईश्वर के कृत्यों,
    //       विस्फोट, श्रम विवाद, उपयोगिताओं की विफलता, सरकारी हस्तक्षेप या किसी
    //       अन्य कार्य या स्थिति के कारण बल के कारण रोका जाता है। किसी अप्रत्याशित
    //       घटना के परिणामस्वरूप इवेंट में किसी प्रतिभागी को हुई किसी देरी या हानि
    //       या प्रतिकूल प्रभाव के लिए टीवीटीएन उत्तरदायी नहीं होगा।
    //     </li>

    //     <li>
    //       यह कार्यक्रम विशुद्ध रूप से सर्वोत्तम प्रयास के आधार पर किया गया है और
    //       इस कार्यक्रम में भाग लेना स्वैच्छिक है। कार्यक्रम में भाग लेने से,
    //       प्रतिभागी कानूनी रूप से बाध्य होंगे, दायित्व से मुक्त होने के लिए, और
    //       हानिरहित टीवीटीएन, और इसके किसी भी सहयोगी, कर्मचारी या एजेंट जो
    //       टीवीटीएन और उसकी सेवाओं / उत्पादों का प्रतिनिधित्व करते हैं या उससे
    //       संबंधित हैं। यह रिलीज व्यक्तिगत चोटों (मृत्यु सहित), संपत्ति के नुकसान
    //       या क्षति के लिए किसी भी गतिविधि के संबंध में या प्रत्यक्ष या
    //       अप्रत्यक्ष रूप से, कार्यक्रम में स्वीकृति, कब्जे या भागीदारी के कारण
    //       किसी भी और सभी देयता के लिए है, चाहे हमारी लापरवाही या योगदान के कारण
    //       हुआ हो।
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>अन्य नियम और शर्तें:</p>
    //   <ul>
    //     <li>
    //       प्रतिभागी एतद्द्वारा प्रतिनिधित्व करते हैं कि वह किसी अन्य तीसरे
    //       पक्ष/एजेंसी के साथ किसी विशेष अनुबंध के तहत नहीं है या टीवीटीएन या
    //       उसके सहयोगियों के साथ एक समझौते में प्रवेश करने के लिए कानून के तहत
    //       किसी भी प्रकार की अयोग्यता के तहत नहीं है, जैसा भी मामला हो।
    //     </li>

    //     <li>
    //       प्रतिभागी स्वीकार करता है कि कार्यक्रम में भाग लेने का उसका अधिकार इन
    //       नियमों और शर्तों के नियमों से बाध्य होकर अच्छा और वैध विचार होगा।
    //     </li>

    //     <li>
    //       कार्यक्रम में भाग लेकर, प्रत्येक प्रतिभागी अपने विवेकाधिकार से
    //       टीवीटीएन द्वारा लिए गए किसी भी निर्णय से बाध्य होने के लिए सहमत होता
    //       है, जिसमें नियम और शर्तों की कोई भी व्याख्या शामिल है। इस संबंध में
    //       किसी भी पत्राचार पर विचार नहीं किया जाएगा और टीवीटीएन का निर्णय अंतिम,
    //       बाध्यकारी और गैर-प्रतियोगी होगा। प्रतिभागी स्वीकार करते हैं कि
    //       कार्यक्रम के हित किसी भी प्रतिभागी के हितों से आगे निकल जाएंगे।
    //     </li>

    //     <li>
    //       यदि किसी भी कारण से कार्यक्रम को योजना के अनुसार आयोजित नहीं किया जा
    //       सकता है, जिसमें बिना किसी सीमा के किसी भी परिचालन या लॉजिस्टिक
    //       मुद्दों, कंप्यूटर वायरस, बग, छेड़छाड़, अनधिकृत हस्तक्षेप, धोखाधड़ी,
    //       तकनीकी विफलताओं, या किसी अन्य कारण से संक्रमण जो प्रशासन, सुरक्षा,
    //       निष्पक्षता, अखंडता, या कार्यक्रम के उचित संचालन को भ्रष्ट या प्रभावित
    //       करता है, या किसी भी अन्य कारण से, टीवीटीएन अपने विवेकाधिकार में, ईवेंट
    //       को रद्द करने, समाप्त करने, संशोधित करने या निलंबित करने का अधिकार
    //       सुरक्षित रखता है।
    //     </li>

    //     <li>
    //       वेबसाइट के उपयोग की शर्तों और वेबसाइट पर उल्लिखित गोपनीयता नीति सहित
    //       अन्य सभी मानक नियम और शर्तें प्रतिभागियों पर लागू होंगी।
    //     </li>

    //     <li>
    //       इस कार्यक्रम के संबंध में नियमों और शर्तों और वेबसाइट पर प्रदर्शित
    //       किसी भी अन्य जानकारी के बीच किसी (यानी वेबसाइट के उपयोग की शर्तें और
    //       गोपनीयता नीति) भी संघर्ष की स्थिति में, इस कार्यक्रम के संबंध में
    //       अक्सर पूछे जाने वाले प्रश्न (यदि कोई हो) सहित, यहां नियम और शर्तें
    //       लागू होंगी।
    //     </li>

    //     <li>
    //       कार्यक्रम और नियम और शर्तें भारत के लागू कानूनों के अनुसार नियंत्रित
    //       और समझी जाएंगी। टीवीटीएन द्वारा किसी भी मामले में इन नियमों और शर्तों
    //       को लागू करने में विफलता को नियम और शर्तों की छूट नहीं माना जाएगा और
    //       किसी भी व्यक्ति द्वारा किसी भी दावे को जन्म नहीं देगा। ये नियम और
    //       शर्तें भारतीय कानूनों के अधीन हैं और नई दिल्ली के न्यायालयों के पास
    //       किसी भी विवाद या यहां से उत्पन्न होने वाले किसी भी मामले के संबंध में
    //       विशेष अधिकार क्षेत्र होगा।
    //     </li>
    //   </ul>
    // </div>
    <div className="rulesContainer">
      <p style={{ fontWeight: "bold" }}>
        T.V. Today Network Limited & Mike Ke Laal Event
      </p>
      <p>
        T.V. Today Network Limited (“TVTN”) is organizing ‘Mumbai Tak Mike
        Check’, an open mike event for poetry, storytelling, stand-up, and
        comedy. For participation in this Event, TVTN is inviting entries
        through this form.
      </p>
      <p>
        {" "}
        Participants are called upon to read and understand the following terms
        and conditions before participating in the Event. Submitting the
        aforesaid details will imply that the participant has read and
        understood the terms and conditions of the Event and undertakes to
        compulsorily abide by it.
      </p>
      <p>
        {" "}
        Terms and Conditions given hereinbelow are part and parcel of this Event
        and equally bound upon the participants.
      </p>
      <p style={{ fontWeight: "bold" }}>TERMS & CONDITIONS</p>
      <p>
        TVTN is organizing an open mic event called ‘Mumbai Tak Mike Check’
        (“Event”). This Event is subject to the following terms & conditions
        (“Terms & Conditions”). If any of the participant(s) do not agree with
        these Terms & Conditions, such participant(s) is/are advised not to
        participate in the Event and TVTN shall have no liability towards such
        participant(s) in any manner whatsoever. Participation or submission of
        entry for the Event, or performing any transaction for the Event shall
        be deemed to be acceptance of the Terms & Conditions by such
        participant(s). TVTN reserves the right in its sole and absolute
        discretion to amend/change/vary/terminate all or any of the terms and
        conditions for the Event or terminate the Event at any time without
        giving any prior notice. By entering into the Event, the participant(s)
        agrees to such terms as may be amended from time to time. TVTN is not
        obligated in any manner whatsoever to compensate any person or persons
        who have participated in the Event.
      </p>
      <p>
        For the purposes of these Terms & Conditions, wherever the context so
        requires, “You” or “Your” shall mean any natural person who is an
        eligible participant in the Event in accordance with the Terms &
        Conditions and the “Company”, “TVTN”, “Us”, “We” and/ or “Our” shall
        mean T.V. Today Network Limited, a company registered under the
        Companies Act, 1956 and having its registered office at F-26, First
        Floor, Connaught Circus, New Delhi– 110001, India.
      </p>
      <p style={{ fontWeight: "bold" }}>Name and Duration of the Event:</p>
      <p style={{ fontWeight: "bold" }}>
        Name of the Event: Mumbai Tak Mike Check
      </p>
      <p>
        <li>
          The Event is scheduled to be held on 19th Feb at Aaj Tak office,
          Mumbai, Maharashtra. TVTN may at its sole discretion extend or limit
          the period of the Event or change the venue of the Event without any
          prior intimation.
        </li>
        {/* <li>
          Please note that TVTN may be running similar activities, contests or
          promotions at the same time as this Event. This Event cannot be
          combined with any other offer or promotion currently being offered by
          TVTN.
        </li>{" "} */}
      </p>
      <p>
        Eligibility:
        <li>
          The Event is only open to the members who are Indian citizens and
          residents of India and are aged 18 years or above and who are
          physically located and residing in India at the time of entry for the
          Event. Participants below 18 years of age may participate in the Event
          through their parents or guardian(s).
        </li>
        <li>
          {" "}
          Employees of TVTN, directors and officers, and their immediate
          families (spouse, parents, children, siblings, and their respective
          spouses), and their respective household members of TVTN, its
          affiliates, subsidiaries, and divisions, advertising and promotion
          agencies, and all others associated with the design, execution,
          production, development, and promotion of this Event or are connected
          to this Event in any way are not eligible to participate in the Event.
        </li>
        <li>
          The participant(s) undertakes, warrants and guarantees to TVTN that
          the participant(s) has the full legal capacity to participate in the
          Event in accordance with these Terms & Conditions.
        </li>
      </p>
      <p>How to Participate: </p>
      <p>
        Eligible participant(s) need to follow the rules mentioned herein below:
        For Audio:
        <li>
          Participant(s) shall attach the full audio recording file of the
          performance (“Audio”) which they intend to perform during the Event,
          if selected.
        </li>
        <li>
          The Audio must be recorded using a mobile phone and should be for a
          maximum duration of 5 (five) minutes.
        </li>
        <li>
          The Audio must be uploaded in either of the following formats, i.e.
          .mp3, .wav., .m4a, .ogg, .wma, .mka, .aac, .midi
        </li>
        <li>The Audio file size must not be more than 10 MB</li>
        <li>
          The Audio should not be of less duration than you intend to perform.
          Attach full audio.
        </li>
        Dont’s:{" "}
        <li>Do not fill this form multiple times. You will be disqualified</li>
        <li>
          Do not call us or mail us to know about the status of your
          application.{" "}
        </li>
      </p>
      <p>Privacy:</p>
      <p>
        <li>
          Participant(s) represents that they are the sole, absolute,
          unencumbered, legal and beneficial owner of all materials to be
          performed at the Event and the rights granted to TVTN and/or its
          assignees. Participant(s) has the authority to grant to TVTN such
          rights and consents granted in the present form and is not under any
          disability, restriction or prohibition which prevents the
          participant(s) from performance or observance any of their
          obligations.
        </li>

        <li>
          By entering into the Event, the participant(s) waives all copyrights,
          rights of publicity and any related rights and consents to TVTN’s
          right to picture, record, tape or portray him/her as a participant(s),
          and to exhibit or communicate to public this material or performance
          in any and all media now existing or hereinafter created, including
          without limitation television, film, radio, digital and print media,
          without any compensation whatsoever for broadcasting, rebroadcasting,
          advertising and publicity purposes, except where prohibited by law.
          The participant(s) consents to TVTN’s right to use his/her name,
          video, voice or picture, or the content of his/her Event
          entry(ies)/performance etc. (collectively, the “Publicity
          Rights”).Notwithstanding a participant's participation in the Event,
          there is no obligation on the part of TVTN to broadcast any
          performance / events in which he/she has taken part, or any or all of
          his / her contribution as recorded by the TVTN.
        </li>
        <li>
          To the extent applicable under law, Participant agrees to hereby
          irrevocably and unconditionally waive the benefit of any provision of
          law to the extent permissible under such law known as “droit moral” or
          any similar law in any country of the world in respect of the exercise
          of TVTN’s rights hereunder, and hereby irrevocably and unconditionally
          grants all necessary consents under any applicable laws and waives its
          moral rights under section 38-B of the Copyright Act, 1957 with all
          the amendments made thereto in respect of its Performance at the
          Event.
        </li>
        <li>
          By making entries/registrations for the purpose of the Event,
          participant(s) consents to and permits TVTN to send SMSs, e-mail or
          call him/ her, whether or not such sender is registered on the
          National Do Not Call registry. 
        </li>

        <li>
          By entering the Event, participant(s) consents to being placed on a
          mailing/SMS list for promotional and other materials for TVTN.
        </li>
        <li>
          Participant(s) shall be subject to the{" "}
          <a href="https://www.indiatodaygroup.com/privacy-policy.html">
            Privacy Policy
          </a>{" "}
          of TVTN as placed on its Website. Please note that providing any
          information to TVTN by a participant(s) is by his choice. By entering
          the Event, a participant(s) agrees to allow TVTN to use the
          information provided by such participant(s).
        </li>
        <li>
          TVTN assumes no responsibility for errors, timeliness, deletion,
          mis-delivery or failure to store any user communications or
          personalization settings.
        </li>
      </p>
      <p>Liability/responsibility:</p>
      <p>
        <li>
          TVTN is not responsible for the accuracy, usefulness, safety, or
          intellectual property rights of or relating to such
          entries/registrations. Participant(s) further understands and
          acknowledges that he/she may be exposed to entries/transactions that
          is inaccurate, offensive, indecent, or objectionable, and he/she
          agrees to waive, and hereby does waive, any legal or equitable rights
          or remedies, that he/she has or may have against TVTN with respect
          thereto, and agrees to indemnify and hold TVTN, its owners/operators,
          affiliates, and/or licensors, harmless to the fullest extent allowed
          by law regarding all matters related to his/her access to or use of
          the website.
        </li>
        <li>
          TVTN, including their divisions, associates, affiliates and
          subsidiaries, and their respective agents, representatives, owners,
          directors, employees, officers, distributors, retailers, and
          advertising/promotion agencies, are not responsible for any loss of
          entries/transactions for any reason whatsoever including, due to any
          problems caused, service providers, technical disruption and/or
          failure/ server problems and/ or any other difficulties faced by the
          participant(s) before or on the last date of filling this form for any
          reason whatsoever or for the entries/transactions received after the
          last date of filling of this form due to any reasons whatsoever.
          Entries/transactions are void if, inaccurate, incomplete, damaged,
          tampered with, falsified, mechanically reproduced, irregular in any
          way or otherwise not in compliance with these Terms & Conditions.
        </li>
        <li>
          TVTN shall not be responsible for any errors or omissions in the Terms
          & Conditions contained herein. All information provided in the Event
          is provided “As is” without warranty of any kind. TVTN makes no
          representations and disclaims all express, implied, and statutory
          warranties of any kind to the participant(s) and/or any third party
          including, without limitation, warranties as to accuracy, timelines,
          completeness, merchantability, or fitness for any particular purpose.
        </li>
        <li>
          Under no circumstance, TVTN or its affiliates and subsidiaries and/or
          their respective agents, representatives, owner’s directors,
          employees, officers, distributors, retailers, and
          advertising/promotion agencies shall be liable to the
          participant(s)/user and/or any third party for any lost profits or
          lost opportunity, indirect, special, consequential, incidental, or
          punitive damages whatsoever, even if TVTN has been advised of the
          possibility of such damages.
        </li>
        <li>
          TVTN or any of its affiliates will not be liable for any loss of
          earnings, or otherwise caused to the participant(s) and arising as a
          result of his/her participation in the Event.
        </li>{" "}
        <li>
          Any failure of TVTN to perform its obligations will be excused to the
          extent such performance is prevented due to reason of force majeure
          such as acts of God, explosion, labour dispute, failure of utilities,
          governmental interference or any other act or condition beyond the
          reasonable control of TVTN (“Force Majeure Event”). TVTN shall be not
          liable for any delay or loss or adverse effect caused to a
          participant(s) in the Event as a result of a Force Majeure Event.
        </li>{" "}
        <li>
          This Event is made purely on a best effort basis and participating in
          this Event is voluntary. By participating in the Event, participant(s)
          will be legally bound hereby, to release from liability, and hold
          harmless TVTN, and any of its affiliates, employees or agents
          representing or related to TVTN and its services/products. This
          release is for any and all liability for personal injuries (including
          death), property loss or damage, in connection with any activity or
          directly or indirectly, by reason of the acceptance, possession, or
          participation in the Event, even if caused or contributed to by our
          negligence.
        </li>
      </p>
      <p>Other Terms & Conditions:</p>
      <p>
        <li>
          {" "}
          The participant(s) hereby represents that he/she is not under any
          exclusive contracts with any other third party/ agency or is not under
          any kind of disqualification under law to enter into an agreement with
          TVTN or its affiliates, as the case may be.
        </li>{" "}
        <li>
          {" "}
          The participant(s) acknowledges that his/her right to participate in
          the Event shall constitute good and valid consideration, binding
          him/her by the terms of these Terms & Conditions.{" "}
        </li>
        <li>
          {" "}
          By participating in the Event, each participant(s) agrees to be bound
          by any decisions made by TVTN in its sole discretion, including any
          interpretations of the Terms & Conditions. No correspondence in this
          regard shall be entertained and TVTN’s decision shall be final,
          binding and non-contestable. Participant(s) acknowledge that the
          interests of the Event shall override those of any participant(s).{" "}
        </li>
        <li>
          The participant(s) agree to not use any offensive or profane language,
          make any racist, hateful, derogatory or discriminatory remarks based
          on religion, race, gender, national origin, age, marital status,
          sexual orientation or disability against any person(s) in the Audio
          and/ or during any and all communication/ performances at the Event.
        </li>
        <li>
          {" "}
          If due to any reason the Event cannot be held as planned, including
          without limitation any operational or logistical issues, infection by
          computer virus, bugs, tampering, unauthorized intervention, fraud,
          technical failures, or any other causes which corrupt or affect the
          administration, security, fairness, integrity, or proper conduct of
          the Event, or for any other reason whatsoever, TVTN reserves the
          right, in its sole discretion, to cancel, terminate, modify or suspend
          the Event.
        </li>
        <li>
          {" "}
          All other standard Terms & Conditions, including the terms of use of
          Website and the privacy policy mentioned on the Website would apply to
          the participant(s).
        </li>
        <li>
          {" "}
          In the event of any conflict between the Terms & Conditions herein,
          and any other information displayed on the Website (i.e. terms of use
          of Website and the privacy policy, including the FAQs (If any), in
          relation to this Event, the Terms & Conditions herein shall prevail.
        </li>
        <li>
          {" "}
          The Event and Terms & Conditions shall be governed by and construed in
          accordance with the applicable laws of India. Failure by TVTN to
          enforce any of these Terms & Conditions in any instance shall not be
          deemed to be a waiver of the Terms & Conditions and shall not give
          rise to any claim by any person. These Terms & Conditions are subject
          to Indian laws and the Courts at New Delhi shall have the exclusive
          jurisdiction in respect of any disputes or any matter arising here
          from.
        </li>
      </p>
    </div>
    // <div className="rulesContainer">
    //   <p style={{ textAlign: "center", fontWeight: "bold" }}>
    //     T.V. Today Network Limited & Mike Ke Laal Event
    //   </p>
    //   T.V. Today Network Limited (
    //   <span style={{ fontWeight: "bold" }}>“TVTN”</span>) is organizing‘Mike Ke
    //   Laal’, an open mike event for poetry, storytelling, stand-up, and comedy.
    //   For participation in this Event, TVTN is inviting entries through this
    //   form. Participants are called upon to read and understand the following
    //   terms and conditions before participating in the Event.Submitting the
    //   aforesaid details will imply that the participant has read and understood
    //   the terms and conditions of the Event and undertakes to compulsorily abide
    //   by it. Terms and Conditions given hereinbelow are part and parcel of this
    //   Event and equally bound upon the participants.
    //   <p style={{ fontWeight: "bold" }}>TERMS & CONDITIONS</p>
    //   TVTN is organizing an open mic event called ‘Mike Ke Laal’ (
    //   <span style={{ fontWeight: "bold" }}>“Event”</span>). This Event is
    //   subject to the following terms & conditions (
    //   <span style={{ fontWeight: "bold" }}>“Terms & Conditions”</span>). If any
    //   of the participant(s) do not agree with these Terms & Conditions, such
    //   participant(s) is/are advised not to participate in the Event and TVTN
    //   shall have no liability towards such participant(s) in any manner
    //   whatsoever. Participation or submission of entry for the Event, or
    //   performing any transaction for the Event shall be deemed to be acceptance
    //   of the Terms & Conditions by such participant(s). TVTN reserves the right
    //   in its sole and absolute discretion to amend/change/vary/terminate all or
    //   any of the terms and conditions for the Event or terminate the Event at
    //   any time without giving any prior notice. By entering into the Event, the
    //   participant(s) agrees to such terms as may be amended from time to time.
    //   TVTN is not obligated in any manner whatsoever to compensate any person or
    //   persons who have participated in the Event. For the purposes of these
    //   Terms & Conditions, wherever the context so requires, “You” or “Your”
    //   shall mean any natural person who is an eligible participant in the Event
    //   in accordance with the Terms & Conditions and the “Company”, TVTN “Us”,
    //   “We” and/ or “Our” shall mean T.V. Today Network Limited, a company
    //   registered under the Companies Act, 1956 and having its registered office
    //   at F-26, First Floor, Connaught Circus, New Delhi– 110001, India.
    //   <p style={{ fontWeight: "bold" }}>Name and Duration of the Event:</p>
    //   <p style={{ fontWeight: "bold" }}>Name of the Event: Mike Ke Laal</p>
    //   <li>
    //     The Eventis scheduled to be held on 18th, 19th and 20thof November, 2023
    //     at Major Dhyan Chand National Stadium, New Delhi. TVTN may at its sole
    //     discretion extend or limit the period of the Eventor change the venue of
    //     the Event without any prior intimation.
    //   </li>
    //   <p style={{ fontWeight: "bold" }}>Eligibility:</p>
    //   <ul>
    //     <li>
    //       The Event is only open to the members who are Indian citizens and
    //       residents of India and are aged 18 years or above and who are
    //       physically located and residing in India at the time of entry for the
    //       Event. Participants below 18 years of age may participate in the Event
    //       through their parents or guardian(s).{" "}
    //     </li>
    //     <li>
    //       Employees of TVTN, directors and officers, and their immediate
    //       families (spouse, parents, children, siblings, and their respective
    //       spouses), and their respective household members of TVTN, its
    //       affiliates, subsidiaries, and divisions, advertising and promotion
    //       agencies, and all others associated with the design, execution,
    //       production, development, and promotion of this Event or are connected
    //       to this Event in any way are not eligible to participate in the Event.
    //     </li>
    //     <li>
    //       The participant(s) undertakes, warrants and guarantees to TVTN that
    //       the participant(s) has the full legal capacity to participate in the
    //       Event in accordance with these Terms & Conditions.
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>How to Participate:</p>
    //   Eligible participant(s) need to follow the rules mentioned here in below:
    //   <p style={{ fontWeight: "bold" }}>For Audio:</p>
    //   <ul>
    //     <li>
    //       Participant(s) shall attach the full audio recording file of the
    //       performance (“Audio”) which they intend to perform during the Event,
    //       if selected.
    //     </li>
    //     <li>
    //       The Audio must be recorded using a mobile phone and should be for a
    //       maximum duration of 5 (five) minutes.
    //     </li>
    //     <li>
    //       The Audio must be uploaded in either of the following formats, i.e.
    //       .mp3, .wav., .m4a, .ogg, .wma, .mka, .aac, .midi
    //     </li>
    //     <li>The Audio file size must not be more than 10 MB</li>
    //     <li>
    //       The Audio should not be of less duration than you intend to perform.
    //       Attach full audio. Dont’s:
    //     </li>
    //     <li>Do not fill this form multiple times. You will be disqualified.</li>
    //     <li>
    //       Do not call us or mail us to know about the status of your
    //       application.
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>Privacy:</p>
    //   <ul>
    //     <li>
    //       Participant(s) represents that they are the sole, absolute,
    //       unencumbered, legal and beneficial owner of all materials to be
    //       performed at the Event and the rights granted to TVTN and/or its
    //       assignees. Participant(s) has the authority to grant to TVTN such
    //       rights and consents granted in the present form and is not under any
    //       disability, restriction or prohibition which prevents the
    //       participant(s) from performance or observance any of their
    //       obligations.
    //     </li>
    //     <li>
    //       By entering into the Event, the participant(s) waives all copyrights,
    //       rights of publicity and any related rights and consents to TVTN’s
    //       right to picture, record, tape or portray him/her as a participant(s),
    //       and to exhibit or communicate to public this material or performance
    //       in any and all media now existing or hereinafter created, including
    //       without limitation television, film, radio, digital and print media,
    //       without any compensation whatsoever for broadcasting, rebroadcasting,
    //       advertising and publicity purposes, except where prohibited by law.
    //       The participant(s) also consents to TVTN’s right to use his/her name,
    //       video, voice or picture, or the content of his/her Event
    //       entry(ies)/performance etc. (collectively, the “Publicity Rights”).
    //       Notwithstanding a participant's participation in the Event, there is
    //       no obligation on the part of TVTN to broadcast any performance /
    //       events in which he/she has taken part, or any or all of his / her
    //       contribution as recorded by the TVTN.
    //     </li>
    //     <li>
    //       To the extent applicable under law, Participant agrees to hereby
    //       irrevocably and unconditionally waive the benefit of any provision of
    //       law to the extent permissible under such law known as “droit moral” or
    //       any similar law in any country of the world in respect of the exercise
    //       of TVTN’s rights hereunder, and hereby irrevocably and unconditionally
    //       grants all necessary consents under any applicable laws and waives its
    //       moral rights under section 38-B of the Copyright Act, 1957 with all
    //       the amendments made thereto in respect of its Performance at the
    //       Event.
    //     </li>
    //     <li>
    //       By making entries/registrations for the purpose of the Event,
    //       participant(s) consents to and permits TVTN to send SMSs, e-mail or
    //       call him/ her, whether or not such sender is registered on the
    //       National Do Not Call registry.{" "}
    //     </li>
    //     <li>
    //       By entering the Event, participant(s) consents to being placed on a
    //       mailing/SMS list for promotional and other materials for TVTN.
    //     </li>
    //     <li>
    //       Participant(s) shall be subject to the{" "}
    //       <a href="https://www.indiatodaygroup.com/privacy-policy.html">
    //         Privacy Policy
    //       </a>{" "}
    //       of TVTN as placed on its Website. Please note that providing any
    //       information to TVTN by a participant(s) is by his choice. By entering
    //       theEvent, a participant(s) agrees to allow TVTN to use the information
    //       provided by such participant(s).
    //     </li>
    //     <li>
    //       TVTN assumes no responsibility for errors, timeliness, deletion,
    //       mis-delivery or failure to store any user communications or
    //       personalization settings.
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>Liability/responsibility:</p>
    //   <ul>
    //     <li>
    //       TVTN is not responsible for the accuracy, usefulness, safety, or
    //       intellectual property rights of or relating to such
    //       entries/registrations. Participant(s) further understands and
    //       acknowledges that he/she may be exposed to entries/transactions that
    //       is inaccurate, offensive, indecent, or objectionable, and he/she
    //       agrees to waive, and hereby does waive, any legal or equitable rights
    //       or remedies,that he/she has or may have against TVTN with respect
    //       thereto, and agrees to indemnify and hold TVTN, its owners/operators,
    //       affiliates, and/or licensors, harmless to the fullest extent allowed
    //       by law regarding all matters related to his/her access to or use of
    //       the website.
    //     </li>
    //     <li>
    //       TVTN, including their divisions, associates, affiliates and
    //       subsidiaries, and their respective agents, representatives, owners,
    //       directors, employees, officers, distributors, retailers, and
    //       advertising/promotion agencies, are not responsible for any loss of
    //       entries/transactions for any reason whatsoever including, due to any
    //       problems caused, service providers, technical disruption and/or
    //       failure/ server problems and/ or any other difficulties faced by the
    //       participant(s) before or on the last date of filling this form for any
    //       reason whatsoever or for the entries/transactions received after the
    //       last date of filling of this form due to any reasons whatsoever.
    //       Entries/transactions are void if, inaccurate, incomplete, damaged,
    //       tampered with, falsified, mechanically reproduced, irregular in any
    //       way or otherwise not in compliance with these Terms & Conditions.
    //     </li>
    //     <li>
    //       TVTN shall not be responsible for any errors or omissions in the Terms
    //       & Conditions contained herein. All information provided in the Event
    //       is provided “As is” without warranty of any kind. TVTN makes no
    //       representations and disclaims all express, implied, and statutory
    //       warranties of any kind to the participant(s) and/or any third party
    //       including, without limitation, warranties as to accuracy, timelines,
    //       completeness, merchantability, or fitness for any particular purpose.
    //     </li>
    //     <li>
    //       Under no circumstance, TVTN or its affiliates and subsidiaries and/or
    //       their respective agents, representatives, owner’s directors,
    //       employees, officers, distributors, retailers, and
    //       advertising/promotion agencies shall be liable to the
    //       participant(s)/user and/or any third party for any lost profits or
    //       lost opportunity, indirect, special, consequential, incidental, or
    //       punitive damages whatsoever, even if TVTN has been advised of the
    //       possibility of such damages.
    //     </li>
    //     <li>
    //       TVTN or any of its affiliates will not be liable for any loss of
    //       earnings, or otherwise caused to the participant(s) and arising as a
    //       result of his/her participation in the Event.
    //     </li>
    //     <li>
    //       Any failure of TVTN to perform its obligations will be excused to the
    //       extent such performance is prevented due to reason of force majeure
    //       such as acts of God, explosion, labour dispute, failure of utilities,
    //       governmental interference or any other act or condition beyond the
    //       reasonable control of TVTN (“Force Majeure Event”). TVTN shall be not
    //       liable for any delay or loss or adverse effect caused to a
    //       participant(s) in the Event as a result of a Force Majeure Event.
    //     </li>
    //     <li>
    //       This Event is made purely on a best effort basis and participating in
    //       this Event is voluntary. By participating in the Event, participant(s)
    //       will be legally bound hereby, to release from liability, and hold
    //       harmless TVTN, and any of its affiliates, employees or agents
    //       representing or related to TVTN and its services/products. This
    //       release is for any and all liability for personal injuries (including
    //       death), property loss or damage, in connection with any activity or
    //       directly or indirectly, by reason of the acceptance, possession, or
    //       participation in the Event, even if caused or contributed to by our
    //       negligence.
    //     </li>
    //   </ul>
    //   <p style={{ fontWeight: "bold" }}>Other Terms & Conditions:</p>
    //   <ul>
    //     <li>
    //       The participant(s) hereby represents that he/she is not under any
    //       exclusive contracts with any other third party/ agency or is not under
    //       any kind of disqualification under law to enter into an agreement with
    //       TVTN or its affiliates, as the case may be.
    //     </li>
    //     <li>
    //       The participant(s) acknowledges that his/her right to participate in
    //       the Event shall constitute good and valid consideration, binding
    //       him/her by the terms of these Terms & Conditions.{" "}
    //     </li>
    //     <li>
    //       By participating in the Event, each participant(s) agrees to be bound
    //       by any decisions made by TVTN in its sole discretion, including any
    //       interpretations of the Terms & Conditions. No correspondence in this
    //       regard shall be entertained and TVTN’s decision shall be final,
    //       binding and non-contestable. Participant(s) acknowledge that the
    //       interests of the Event shall override those of any participant(s).
    //     </li>
    //     <li>
    //       If due to any reason the Event cannot be held as planned, including
    //       without limitation any operational or logistical issues, infection by
    //       computer virus, bugs, tampering, unauthorized intervention, fraud,
    //       technical failures, or any other causes which corrupt or affect the
    //       administration, security, fairness, integrity, or proper conduct of
    //       the Event, or for any other reason whatsoever, TVTN reserves the
    //       right, in its sole discretion, to cancel, terminate, modify or suspend
    //       the Event.
    //     </li>
    //     <li>
    //       All other standard Terms & Conditions, including the terms of use of
    //       Website and the privacy policy mentioned on the Website would apply to
    //       the participant(s).
    //     </li>
    //     <li>
    //       In the event of any conflict between the Terms & Conditions herein,
    //       and any other information displayed on the Website (i.e. terms of use
    //       of Website and the privacy policy, including the FAQs (If any), in
    //       relation to this Event, the Terms & Conditions herein shall prevail.
    //     </li>
    //     <li>
    //       The Event and Terms & Conditions shall be governed by and construed in
    //       accordance with the applicable laws of India. Failure by TVTN to
    //       enforce any of these Terms & Conditions in any instance shall not be
    //       deemed to be a waiver of the Terms & Conditions and shall not give
    //       rise to any claim by any person. These Terms & Conditions are subject
    //       to Indian laws and the Courts at New Delhi shall have the exclusive
    //       jurisdiction in respect of any disputes or any matter arising here
    //       from.
    //     </li>
    //   </ul>
    // </div>
  );
}
